import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

import {
	GroupingState,IntegratedGrouping
	
} from '@devexpress/dx-react-grid';

import {
	Grid, VirtualTable,
	TableGroupRow,TableColumnResizing,
	TableHeaderRow,GroupingPanel,Toolbar
} from '@devexpress/dx-react-grid-material-ui';

const styles = {
	tableHeader: {
		'& tbody tr td': {
			/*
			textOverflow:'inherit !important',
			overflow:'visible !important',
			whiteSpace:'pre-wrap !important'
			*/
		}
	},
};

const TableComponentBase = ({ classes, ...restProps }) => (
	<VirtualTable.Table
		{...restProps}
		className={classes.tableHeader}
	/>
);

export const TableComponent = withStyles(styles, { name: 'TableComponent' })(TableComponentBase);

const getRowId = row => row.id;

const getColumnWidth = (columns) =>{
	
	
	const width = getDefaultColumnWidth(columns);
	return columns.map((row)=>{
		return {columnName:row.name, width:(row.width) ? row.width : width}
	})
};

const getDefaultColumnWidth = (columns) =>{
	const grid = document.getElementById("simpleTableGrid");
	if(grid){
		let width = Math.floor(grid.clientWidth / columns.length);
		if(width < 100) width = 100;
		return width;
	}
	else{
		return 100
	}
};

class simpleTable extends Component {
	constructor(props) {
		super(props);
		this.state = {
			IsProcess : false,
			rows: props.dataSource,
			columnWidths: [],
			
		}
	}
	componentDidMount(){
		const columnWidths = getColumnWidth(this.props.columns);
		this.setState({
			columnWidths
		});
		
		
	}

	UNSAFE_componentWillReceiveProps(nextProps){
		if(nextProps.dataSource !== this.props.dataSource){
			this.setState({
				rows: nextProps.dataSource
			})
		}
	}
	
	handleColumnWidthChange = (columnWidths) =>{
		this.setState({ columnWidths });
	};
	
	

	

	render() {
		const {rows,columnWidths} = this.state;
		const {columns, isGrouping,groupingColumns,defaultExpandedGroups} = this.props;
		
		const height = (this.props.navigation.windowHeight * 0.7) - 65;
		return(
			<Paper className={"overray_paper"} id={"simpleTableGrid"}>
				<Grid
					rows={rows}
					columns={columns}
					getRowId={getRowId}
					
					
				>
					{isGrouping &&
					<GroupingState
						defaultGrouping={[{columnName: groupingColumns}]}
						defaultExpandedGroups={defaultExpandedGroups}
					/>
					}
					{isGrouping &&
					<IntegratedGrouping/>
					}
					<VirtualTable
						height={height}
						tableComponent={TableComponent}
					/>
					<TableColumnResizing
						columnWidths={columnWidths}
						onColumnWidthsChange={this.handleColumnWidthChange}
					/>
					<TableHeaderRow />
					{isGrouping &&
					<TableGroupRow/>
					}
					{isGrouping &&
					<Toolbar/>
					}
					{isGrouping &&
					<GroupingPanel />
					}
				</Grid>
			</Paper>
		);
	}
}

simpleTable.propTypes = {
	dataSource: PropTypes.array,
	columns : PropTypes.array,
	isGrouping : PropTypes.bool,
	groupingColumns : PropTypes.string,
	defaultExpandedGroups : PropTypes.array
	
};
simpleTable.defaultProps = {
	dataSource: [],
	columns: [],
	isGrouping : false,
	defaultExpandedGroups:[]
};
function mapStateToProps(state) {
	return {
		auth: state.auth,
		navigation : state.navigation
	};
}
export default connect(mapStateToProps)(simpleTable);


// WEBPACK FOOTER //
// ./src/common/components/table/simple-table.js